module.exports = __webpack_public_path__ + "img/icons BFr_36.d0e25161.svg";